import { Location as NgLocation } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { CwButton, CwCard, CwImage } from '@bbraun/cortex-angular';
import { TranslocoDirective } from '@jsverse/transloco';

import { ROUTES } from '../../definitions/constants/routes.constants';

@Component({
  selector: 'app-portal-page',
  imports: [
    CwCard,
    CwImage,
    CwButton,
    TranslocoDirective
  ],
  templateUrl: './portal-page.component.html',
  styleUrl: './portal-page.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class PortalPageComponent {
  private readonly window = window;
  private readonly ngLocation = inject(NgLocation);

  protected readonly ROUTES = ROUTES;

  public onReplenishmentSelected(): void {
    this.ngLocation.go(ROUTES.REPLENISHMENT);
    this.window.location.reload();
  }

  public onRepEvolutionSelected(): void {
    this.ngLocation.go(ROUTES.REP_EVOLUTION);
    this.window.location.reload();
  }
}
